/* eslint-disable react/prop-types */
import React from 'react';

export const StatusPill = ({ dotColor, status }) => {
  return (
    <span
      className={`inline-block w-1.5 h-1.5 rounded-full flex-shrink-0 ${status === 'pending' ? 'animate-pulse' : ''}`}
      style={{
        backgroundColor: dotColor,
        boxShadow: `0 0 0 2px var(--bg-card), 0 0 0 3px ${dotColor}`,
      }}
    />
  );
};

const STATUS_CONFIG = {
  approved: {
    text:     'Approved',
    dotColor: '#3FEFA6',
    color:    'var(--accent)',
  },
  pending: {
    text:     'Pending',
    dotColor: '#EAB308',
    color:    '#ca8a04',
  },
  draft: {
    text:     'Draft',
    dotColor: 'var(--text-ghost)',
    color:    'var(--text-muted)',
  },
  published: {
    text:     'Published',
    dotColor: '#2DD4BF',
    color:    'var(--brand)',
  },
  failed: {
    text:     'Failed',
    dotColor: '#ef4444',
    color:    '#dc2626',
  },
  stopped: {
    text:     'Stopped',
    dotColor: '#ef4444',
    color:    '#dc2626',
  },
};

const Status = ({ status, className = '', ...props }) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.pending;

  return (
    <span
      className={`inline-flex items-center gap-1.5 text-xs font-medium ${className}`}
      style={{ color: config.color }}
      {...props}
    >
      <StatusPill dotColor={config.dotColor} status={status} />
      {config.text}
    </span>
  );
};

export default Status;
